import { render, staticRenderFns } from "./GatewayAddEndpoint.vue?vue&type=template&id=0d72119f&scoped=true"
import script from "./GatewayAddEndpoint.vue?vue&type=script&lang=js"
export * from "./GatewayAddEndpoint.vue?vue&type=script&lang=js"
import style0 from "./GatewayAddEndpoint.vue?vue&type=style&index=0&id=0d72119f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d72119f",
  null
  
)

export default component.exports